import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLang } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { ArrowRight, Beaker, Cpu, Lock } from "lucide-react";

const INTERNAL_APP_PATH = "/perfumery-tech-app";

export default function PerfumeryTech() {
  const { tr } = useLang();
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleContinue = () => {
    if (user) {
      navigate(INTERNAL_APP_PATH);
    } else {
      navigate(`/login?redirect=${encodeURIComponent(INTERNAL_APP_PATH)}`);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-10 py-10">
        <div className="pfi-overline inline-flex items-center gap-2"><Beaker size={12} /> {tr("tech_headline")}</div>
        <h1 className="mt-3 font-serif text-3xl sm:text-5xl">PERSONA <span className="text-[#e6c687]">PERFUMERY TECH</span></h1>
        <p className="mt-4 text-[#a9a9b8] max-w-2xl">{tr("tech_desc")}</p>

        <div className="mt-8 grid md:grid-cols-3 gap-4">
          <Card icon={<Cpu size={18} />} title="PERSONA AI PERFUMER" text={tr("tech_distinction_ai")} />
          <Card icon={<Beaker size={18} />} title="PERSONA PERFUMERY TECH" text={tr("tech_distinction_tech")} accent />
          <Card icon={<Lock size={18} />} title="PERSONA CORE" text={tr("tech_distinction_core")} />
        </div>

        <div className="mt-10 pfi-card p-8 relative overflow-hidden">
          <div className="absolute inset-0 pfi-shimmer opacity-[0.05]" />
          <div className="relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <div className="pfi-overline">Official Gateway</div>
              <div className="mt-2 font-serif text-2xl">Continue to the official PERSONA technology</div>
              <p className="mt-2 text-[#a9a9b8] text-sm max-w-xl">
                The official personalized fragrance experience is powered by the protected proprietary PERSONA CORE technology. Continue to the official portal.
              </p>
            </div>
            <button
              data-testid="tech-continue-cta"
              type="button"
              onClick={handleContinue}
              className="pfi-btn-gold rounded-full px-6 py-3.5 text-sm inline-flex items-center gap-2"
            >
              {tr("tech_cta")} <ArrowRight size={14} />
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Card({ icon, title, text, accent }) {
  return (
    <div className={"pfi-card p-6 " + (accent ? "border-[#d4af37]/40" : "")}>
      <div className="pfi-overline inline-flex items-center gap-2">{icon}{title}</div>
      <p className="mt-3 text-sm text-[#c8c8d4] leading-relaxed">{text}</p>
    </div>
  );
}
